if ( typeof URLSearchParams === 'function' ) {
    Array.prototype.forEach.call( document.querySelectorAll( '.js-login-button' ), function ( button ) {
        const params = new URLSearchParams( button.search );
        if ( !params.has( 'r' ) && button.pathname !== location.pathname ) {
            params.append( 'r', location.href );
            button.search = params.toString();
        }
    } );
}
